<template>
  <div class="row mr-2">
    <v-spacer></v-spacer>
    <v-select
      v-model="searchParams.searchColumn"
      :items="searchColumns"
      item-text="text"
      item-value="value"
      label="Select column"
      single-line
      hide-details
      class="mr-3"
      max-width="200px"
    ></v-select>
    <v-text-field
      v-model="searchParams.tableSearch"
      append-icon="mdi-table-search"
      label="Search..."
      single-line
      clearable
      hide-details
      @input="customSearch"
    ></v-text-field>
  </div>
</template>
<script>
export default {
  props: {
    searchColumns: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      searchParams: {
        searchColumn: '',
        tableSearch: ''
      },
      tableSearchTimeout: false
    }
  },
  methods: {
    // This will trigger when either of the search inputs is changed
    customSearch () {
      if (this.searchParams.searchColumn !== '') {
        // Stop timeout to prevent search from firing while user is still typing
        clearTimeout(this.tableSearchTimeout)
        // Set a timeout to fire search after the user has stopped typing
        this.tableSearchTimeout = setTimeout(() => {
          const searchParams = this.searchParams
          this.$emit('search-query', searchParams)
        }, 600)
      }
    }
  }
}
</script>
